import styled from "styled-components";

export const SurveyPage = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  flex-direction: column;
`;
